











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class MelosTabbar extends Vue {
  @Prop() private tabs!: string[];
  @Prop() private activeTab!: string;
}

